import React from "react";
import css from "./PluginsIntro.module.css";
import {Badge,NoticeView,Title} from "Components";


export default function PluginsIntro(props){
    const {}=props;
    return (
        <div className={`${css.pluginsintro} ${props.className||""}`}>
            <Title>supported cordova platforms</Title>
            <ul className={css.platforms}>
                {statics.platfoms.map(({id,label})=>(
                    <li key={id}>
                        <span className={css.name}>Cordova-{id}</span>
                        {label&&<Badge text={label}/>}
                    </li>
                ))}
            </ul>
            <NoticeView text={`
                For Android, all plugins were tested using cordova-android version 
                <b>14.0.1</b>, and compile SDK version <b>35</b>.
            `}/>
        </div>
    )
}

const statics={
    platfoms:[
        {id:"android",label:"^14.0.0"},
        {id:"iOS",label:"^7.0.0"},
        {
            id:"browser",
            label:"dev only",
        },
    ],
}
